import { Image } from '@orobix/orobix-fe-components'

import { vars } from '../../utils/appConfig'
import aiGoLogo from './assets/logo-ai-go.svg'

const AppLogo = () => (
  <Image src={aiGoLogo} width="64" alt={`${vars.appName} Logo`} />
)

export default AppLogo
